import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { isPublicAppRoute, LOCAL_VAR } from '@app/core/constants';
import { filter, map, mergeMap } from 'rxjs/operators';

import { ErrorMessageService } from './core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'app';
  pageInfo: any;
  liveMode: boolean;
  windowScrolled: boolean;
  topOffset: number = 150;
  private sessionCheckInterval: any;
  private isLoggingOut = false;
  private hasResolvedRoute = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private errorMessageService: ErrorMessageService,
    private authenticationService: AuthenticationService
  ) {
    // REF for unsubscribe: https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map(route => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter(route => route.outlet === 'primary'),
        mergeMap(route => route.data)
      )
      .subscribe(event => {
        this.errorMessageService.clear();
        this.hasResolvedRoute = true;
        this.enforceCredentialsSession();

        const prefix = '';
        // if (!this.liveMode && event && event.testLabel === true) {
        //   prefix = '';
        // }

        this.titleService.setTitle(
          `${prefix}${
            event['title'] ? event['title'] : 'Producer Information Portal'
          }`
        );
        setTimeout(() => {
          this.titleService.setTitle(
            `${prefix}${
              event['title'] ? event['title'] : 'Producer Information Portal'
            }`
          );
        }, 500);
        this.pageInfo = event;
      });
  }

  ngOnInit() {
    // Wait for NavigationEnd before enforcing — cold load of public auth URLs
    // can briefly report router.url as "/" and wrongly redirect to login.
    this.sessionCheckInterval = setInterval(
      () => this.enforceCredentialsSession(),
      1500
    );
  }

  ngOnDestroy() {
    if (this.sessionCheckInterval) {
      clearInterval(this.sessionCheckInterval);
    }
  }

  @HostListener('window:storage', ['$event'])
  onStorageChange(event: StorageEvent) {
    if (!event.key || event.key === LOCAL_VAR.credentialsKey) {
      this.enforceCredentialsSession();
    }
  }

  @HostListener('window:focus', [])
  onWindowFocus() {
    this.enforceCredentialsSession();
  }

  private enforceCredentialsSession() {
    if (!this.hasResolvedRoute || this.isLoggingOut) {
      return;
    }
    const url = this.router.url.split('?')[0] || '';
    if (!url || url === '/' || isPublicAppRoute(url)) {
      return;
    }
    if (!this.authenticationService.isAuthenticated()) {
      this.isLoggingOut = true;
      localStorage.removeItem(LOCAL_VAR.selectedAgent);
      this.authenticationService.logout(true).subscribe(() => {
        this.router.navigate(['/login'], { replaceUrl: true }).then(() => {
          this.isLoggingOut = false;
        });
      });
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (
      window.pageYOffset > this.topOffset ||
      document.documentElement.scrollTop > this.topOffset ||
      document.body.scrollTop > this.topOffset
    ) {
      this.windowScrolled = true;
    } else if (
      (this.windowScrolled && window.pageYOffset) ||
      document.documentElement.scrollTop ||
      document.body.scrollTop < 10
    ) {
      this.windowScrolled = false;
    }
  }


  scrollToTop() {
    (function smoothscroll() {
      var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;

      if (currentScroll > 0) {
        window.requestAnimationFrame(smoothscroll);
        window.scrollTo(0, currentScroll - currentScroll / 8);
      }
    })();
  }
}
